'use client';
import Image from 'next/image';
import Link from 'next/link';

const PartnersSection = () => {
  const topRowPartners = [
    { src: "/images/globalblockchainshow.svg", alt: "globalblockchainshow", href:'https://www.globalblockchainshow.com/' },
    { src: "/images/globalgamesshow.svg", alt: "globalgamesshow.svg", href:'https://www.globalgamesshow.com/' },
  ];

const mediaPartners = [
  {
    src: "/images/livebitcoin-news.svg",
    alt: "livebitcoin-news",
    href: "https://www.livebitcoinnews.com/",
  },
  {
    src: "/images/coinfea-logo.webp",
    alt: "coinfea-logo",
    href: "https://coinfea.com/",
  },
  {
    src: "/images/keydifference.webp",
    alt: "keydifference",
    href: "https://keydifference.com/wire/",
  },
  {
    src: "/images/cryptopolitan-logo.webp",
    alt: "cryptopolitan-logo",
    href: "https://www.cryptopolitan.com/",
  },
  {
    src: "/images/forexpenguin.webp",
    alt: "Forex Penguin",
    href: "https://www.forexpenguin.com/",
  },
  {
    src: "/images/bitcoininsider.webp",
    alt: "Bitcoin Insider",
    href: "https://www.bitcoininsider.org/",
  },
  {
    src: "/images/crypto-news.webp",
    alt: "crypto-news",
    href: "https://crypto.news/",
  },
  {
    src: "/images/theholycoins.webp",
    alt: "The Holy Coins",
    href: "https://theholycoins.com/",
  },
  {
    src: "/images/blockchainreporter.webp",
    alt: "blockchainreporter",
    href: "https://blockchainreporter.net/",
  },
  {
    src: "/images/coinaute.webp",
    alt: "Coinaute",
    href: "https://coinaute.com/",
  },
  {
    src: "/images/bitcoin-world.webp",
    alt: "bitcoin-world",
    href: "https://bitcoinworld.co.in/",
  },
  {
    src: "/images/embassyofbitcoin.webp",
    alt: "Embassy of Bitcoin",
    href: "https://www.embassyofbitcoin.com/",
  },
  {
    src: "/images/gbc-logo.webp",
    alt: "gbc-logo",
    href: "https://gbc-time.org/",
  },
  {
    src: "/images/blockchainmedia.webp",
    alt: "blockchainmedia",
    href: "https://blockchainmedia.id/",
  },
  {
    src: "/images/cryptonomist.webp",
    alt: "The Cryptonomist",
    href: "https://en.cryptonomist.ch/",
  },
  {
    src: "/images/toktimes.webp",
    alt: "TokTimes",
    href: "https://toktimes.com/",
  },
  {
    src: "/images/cryptobrowser-colored.webp",
    alt: "Crypto Browser",
    href: "https://cryptobrowser.io/",
  },
  {
    src: "/images/financialmarkets.webp",
    alt: "Financial Markets",
    href: "http://www.financialmarkets.media/",
  },
  {
    src: "/images/droomdroom-black.webp",
    alt: "DroomDroom",
    href: "https://droomdroom.com/",
  },
  {
    src: "/images/block24seven.webp",
    alt: "Block24Seven",
    href: "https://block24seven.com/",
  },
  {
    src: "/images/bdventures.webp",
    alt: "BD Ventures",
    href: "https://www.bdventures.vn/",
  },
  {
    src: "/images/coincodex-colored.webp",
    alt: "CoinCodex",
    href: "https://coincodex.com/",
  },
  {
    src: "/images/coincarp.webp",
    alt: "CoinCarp",
    href: "https://www.coincarp.com/",
  },
  {
    src: "/images/coincheckup.webp",
    alt: "CoinCheckup",
    href: "https://coincheckup.com/",
  },
  {
    src: "/images/coinpaper.webp",
    alt: "Coinpaper",
    href: "https://coinpaper.com/",
  },
  {
      src: "/images/bftimes.webp",
      alt: "bfmtimes",
      href: "https://bfmtimes.com/",
    },
    {
      src: "/images/nendigital.webp",
      alt: "nendigital",
      href: "https://www.nendigital.com/",
    },
    {
      src: "/images/zexprwire.webp",
      alt: "zexprwire",
      href: "https://zexprwire.com/",
    },
];

  return (
    <>
      {/* Partners & Collaborators Section */}
      <section data-component-id="src/app/PartnersSection.tsx:157:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="157" data-component-end-line="190" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22partners%22%2C%22className%22%3A%22w-full%20relative%20mt-16%20sm%3Amt-20%20lg%3Amt-%5B100px%5D%22%7D" id="partners" className="w-full relative mt-16 sm:mt-20 lg:mt-[100px]">
        <div data-component-id="src/app/PartnersSection.tsx:158:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="158" data-component-end-line="189" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1658px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-6%22%7D" className="w-full max-w-[1658px] mx-auto px-4 sm:px-6 lg:px-6">
          <div data-component-id="src/app/PartnersSection.tsx:159:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="159" data-component-end-line="188" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20gap-6%20sm%3Agap-8%20lg%3Agap-10%22%7D" className="flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
            <h2 data-component-id="src/app/PartnersSection.tsx:160:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="160" data-component-end-line="165" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B15px%5D%20sm%3Atext-%5B16px%5D%20lg%3Atext-%5B24px%5D%20font-bold%20leading-%5B30px%5D%20text-center%20uppercase%20text-text-primary%20%20text-%5B%23FFDD15%5D%22%2C%22textContent%22%3A%22Past%20Partners%20%26%20Collaborators%22%7D"
              className="text-[15px] sm:text-[16px] lg:text-[24px] font-bold leading-[30px] text-center uppercase text-text-primary  text-[#FFDD15]"
              style={{ fontFamily: 'oxanium' }}
            >
              Past Partners & Collaborators
            </h2>

            <div data-component-id="src/app/PartnersSection.tsx:167:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="167" data-component-end-line="187" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%22%7D" className="w-full">
              <div data-component-id="src/app/PartnersSection.tsx:168:14" data-component-path="src/app/PartnersSection.tsx" data-component-line="168" data-component-end-line="186" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20justify-center%20flex-wrap%20gap-6%20sm%3Agap-8%20rounded-lg%20p-6%22%7D" className="flex justify-center flex-wrap gap-6 sm:gap-8 rounded-lg p-6">
                {topRowPartners.map((partner, index) => (
                  <Link data-component-id="src/app/PartnersSection.tsx:170:18" data-component-path="src/app/PartnersSection.tsx" data-component-line="170" data-component-end-line="184" data-component-file="PartnersSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%7D"
                    key={index}
                    href={partner.href}
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                  >
                    <Image data-component-id="src/app/PartnersSection.tsx:176:20" data-component-path="src/app/PartnersSection.tsx" data-component-line="176" data-component-end-line="183" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22bg-%5B%23fff%5D%20p-3%20rounded-%5B5px%5D%20object-contain%20w-%5B200px%5D%20h-%5B100px%5D%20hover%3Aopacity-80%20transition-opacity%20cursor-pointer%22%7D"
                      src={partner.src}
                      alt={partner.alt}
                      width={200}
                      height={100}
                      unoptimized
                      className="bg-[#fff] p-3 rounded-[5px] object-contain w-[200px] h-[100px] hover:opacity-80 transition-opacity cursor-pointer"
                    />
                  </Link>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Media Partners Section */}
      <section data-component-id="src/app/PartnersSection.tsx:193:6" data-component-path="src/app/PartnersSection.tsx" data-component-line="193" data-component-end-line="229" data-component-file="PartnersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22media-partners%22%2C%22className%22%3A%22w-full%20relative%20mt-6%20sm%3Amt-8%20lg%3Amt-10%22%7D" id="media-partners" className="w-full relative mt-6 sm:mt-8 lg:mt-10">
        <div data-component-id="src/app/PartnersSection.tsx:194:8" data-component-path="src/app/PartnersSection.tsx" data-component-line="194" data-component-end-line="228" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1300px%5D%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-6%20py-10%20sm%3Apy-8%20lg%3Apy-10%22%7D" className="w-full max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-6 py-10 sm:py-8 lg:py-10">
          <div data-component-id="src/app/PartnersSection.tsx:195:10" data-component-path="src/app/PartnersSection.tsx" data-component-line="195" data-component-end-line="227" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%20gap-6%20sm%3Agap-8%20lg%3Agap-10%22%7D" className="flex flex-col items-center gap-6 sm:gap-8 lg:gap-10">
            <h2 data-component-id="src/app/PartnersSection.tsx:196:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="196" data-component-end-line="201" data-component-file="PartnersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-%5B24px%5D%20sm%3Atext-%5B32px%5D%20lg%3Atext-%5B40px%5D%20font-bold%20leading-tight%20text-center%20uppercase%20text-white%22%2C%22textContent%22%3A%22Media%20Partners%22%7D"
              className="text-[24px] sm:text-[32px] lg:text-[40px] font-bold leading-tight text-center uppercase text-white"
              style={{ fontFamily: 'Geologica' }}
            >
              Media Partners
            </h2>

            <div data-component-id="src/app/PartnersSection.tsx:203:12" data-component-path="src/app/PartnersSection.tsx" data-component-line="203" data-component-end-line="226" data-component-file="PartnersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20lg%3Agrid-cols-6%20xl%3Agrid-cols-7%20gap-4%20sm%3Agap-5%20lg%3Agap-6%20justify-items-center%22%7D" className="w-full grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 xl:grid-cols-7 gap-4 sm:gap-5 lg:gap-6 justify-items-center">
              {mediaPartners.map((partner, index) => (
                <Link data-component-id="src/app/PartnersSection.tsx:205:16" data-component-path="src/app/PartnersSection.tsx" data-component-line="205" data-component-end-line="224" data-component-file="PartnersSection.tsx" data-component-name="Link" data-component-content="%7B%22elementName%22%3A%22Link%22%2C%22className%22%3A%22flex%20justify-center%20items-center%22%7D"
                  key={index}
                  href={partner.href}
                  target="_blank"
                  rel={
                    partner.href === "https://www.cryptonewsz.com/"
                      ? "noopener noreferrer"
                      : "noopener noreferrer nofollow"
                  }
                  className="flex justify-center items-center"
                >
                  <Image data-component-id="src/app/PartnersSection.tsx:216:18" data-component-path="src/app/PartnersSection.tsx" data-component-line="216" data-component-end-line="223" data-component-file="PartnersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22bg-%5B%23fff%5D%20p-3%20rounded-%5B5px%5D%20object-contain%20w-%5B200px%5D%20h-%5B130px%5D%20hover%3Aopacity-80%20transition-opacity%22%7D"
                    src={partner.src}
                    alt={partner.alt}
                    width={200}
                    height={100}
                    unoptimized
                    className="bg-[#fff] p-3 rounded-[5px] object-contain w-[200px] h-[130px] hover:opacity-80 transition-opacity"
                  />
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PartnersSection;